/**
 * Minimal pub/sub utility inspired by the Shopify Dawn theme.
 * Provides a simple event bus for future section-to-section communication.
 */

window.Shopify = window.Shopify || {};

window.Shopify.PubSub = window.Shopify.PubSub || (function () {
  const events = {};

  return {
    subscribe: function (event, callback) {
      if (!events[event]) {
        events[event] = [];
      }
      events[event].push(callback);
    },

    publish: function (event, data) {
      if (!events[event]) {
        return;
      }
      events[event].forEach(function (callback) {
        callback(data);
      });
    }
  };
}());
